module.exports = __webpack_public_path__ + "img/follow.4fa0f1f0.png";